'use client'

import { RefObject, useEffect, useRef, useState } from 'react'

type Options = {
  /**
   * The default state of the element.
   *
   * @default false
   */
  defaultState?: boolean
} & IntersectionObserverInit

export const useIsElementInViewport = (elementIdOrRef: string | RefObject<HTMLElement | null>, options?: Options) => {
  const [isVisible, setIsVisible] = useState(options?.defaultState ?? false)
  const observerRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    const element =
      typeof elementIdOrRef === 'string' ? document.getElementById(elementIdOrRef) : elementIdOrRef.current
    if (!element) return

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry) {
        setIsVisible(entry.isIntersecting)
      }
    }, options)

    observerRef.current = observer
    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [elementIdOrRef, options])

  return isVisible
}
